import type { JSX } from 'react';

import { cn } from '@change/ds-utils';

import { Text } from '@change/ds-core-ui/next';

import type { TranslationKey } from '@change-corgi/core/i18n';
import { Translate } from '@change-corgi/core/react/i18n';

// eslint-disable-next-line @change/sibling-module-imports
import { useShareButton } from 'src/app/shared/components/ShareButton/hooks/useShareButton';

import { CHANNEL_META } from '../../constants';
import type { SupportedChannel } from '../../types';

type SharePetitionButtonProps = {
	channel: SupportedChannel;
	action: () => Promise<boolean> | Promise<void>;
	label: TranslationKey;
	successLabel?: TranslationKey;
};

export function SharePetitionButton({ channel, action, label, successLabel }: SharePetitionButtonProps): JSX.Element {
	const { data, actions } = useShareButton({ action, label, successLabel });
	const { Icon, className } = CHANNEL_META[channel];

	return (
		<button
			type="button"
			className="flex w-20 flex-col items-center gap-1 lg:w-auto"
			data-testid={`share-petition-button-${channel}`}
			data-qa={`share-social-${channel}`}
			onClick={actions.share}
		>
			<div className={cn('flex w-fit flex-col items-center justify-center rounded-full p-3', className)}>
				<Icon className="h-full w-full" svgClassName="w-full h-full" size={24} />
			</div>
			<Text aria-live="polite" as="span" className="text-size-body-small leading-5">
				<Translate value={data.buttonLabel} />
			</Text>
		</button>
	);
}
